import React from "react";
import { MIN_WORKING_HOURS, MAX_WORKING_HOURS } from "consts";
//
import { TimeAutoSuggest } from "containers/components/autoSuggest";

const PresenceStartTimeAutoSuggest = (props) => (
    <TimeAutoSuggest
        label="Start time"
        minHour={MIN_WORKING_HOURS}
        maxHour={MAX_WORKING_HOURS}
        appendMinutesAfterMaxHour={false}
        {...props}
    />
);

export default PresenceStartTimeAutoSuggest;
